import { useQuery } from "@tanstack/react-query";
import {
  getObsoleteCandidates,
  filterObsoleteCandidates,
} from "@/shared/actions/campanas/migracion.actions";

interface ObsoleteFilters {
  zone?: string;
  plan?: string;
  fromDate?: string;
  toDate?: string;
}

type DataSourceType = "" | "CSV" | "INTERNAL_SEARCH";

export const useObsoleteCandidates = (
  page: number,
  size: number,
  filters?: ObsoleteFilters,
  dataSource?: DataSourceType
) => {
  const hasFilters =
    !!filters?.zone ||
    !!filters?.plan ||
    !!filters?.fromDate ||
    !!filters?.toDate;

  const query = useQuery({
    queryKey: ["obsolete-candidates", page, size, filters, dataSource],
    queryFn: () =>
      hasFilters
        ? filterObsoleteCandidates(page, size, filters || {}, dataSource)
        : getObsoleteCandidates(page, size, dataSource),
    enabled: !!dataSource,
    refetchOnWindowFocus: false,
  });

  return {
    data: query.data,
    loading: query.isLoading,
    refetch: query.refetch,
  };
};